import { css } from '@emotion/react';

export const achievementTileIconContainer = css`
  position: relative;
`;

export const iconContainer = css`
  &.isLocked {
    filter: brightness(0.6);
  }
`;

export const lockIcon = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
